import '/app/styles/cp.scss';
import '/app/styles/pace.scss';
import '/app/styles/main.scss';

import $ from 'jquery';
import Granim from 'granim';
import debounce from 'lodash';

import Flickity from "flickity";
import imagesLoaded from 'imagesloaded';

var Attorney = {
  init: function() {
    $('.attorney-bio-section .item').each(function() {
      var $item = $(this);
      var $headline = $item.find('h4');
      var $text = $item.find('.text');
      $headline.on('click', function() {
        $text.slideToggle();
        $item.toggleClass('active');
      });
    });
  }
};

var global = {
  page_gradient: function() {
    new Granim({
      element: '#gradient-background',
      direction: 'top-bottom',
      states: {
        "default-state": {
          gradients: [
            ['#b7b7b7', '#b7b7b7'],
            ['#5A97CA', '#b7b7b7']
          ],
          loop: false
        }
      }
    });
  },

  jump_to_top: function() {
    function scroll_to(target) {
      var distance = Math.abs(window.pageYOffset - target);
      $('html,body').animate({
        scrollTop: target
      }, distance / 2);
    }
    $('#jump-to-top').click(function() {
      scroll_to(0);
    });
  },

  fix_page_height: function() {
    function compute() {
      var content_height = $('#viewport').innerHeight(),
        body_height = $('body').innerHeight();
      if(content_height < body_height) {
        $('body').addClass('height-fix');
      }
    }
    compute();
    $(window).resize(window._.throttle(compute, 100));
  },

  check_for_tab: function() {
    $('body').keydown(function(e) {
      if(e.originalEvent.keyCode === 9) {
        $('body').addClass('outlines');
      }
    });
  },

  hamburgers: function() {
    $('.hamburger').click(function() {
      $('.hamburger').toggleClass('active');
      $('body').toggleClass('nav-active');
    });
  },

  replace_nbsp: function() {
    if($('.attorney-page').length) {
      var raw = $('.attorney-page .text-section_details').html();
      $('.attorney-page .text-section_details').html(raw.replace('$nbsp;', '&nbsp;'));
    }
  },

  gallery: function() {

    function change_arrows(el) {
      var $el = $(el);
      var $prev = $el.find('.flickity-prev-next-button.previous');
      var $next = $el.find('.flickity-prev-next-button.next');
      var $arrow = $('<svg width="172px" height="9px" viewBox="0 0 172 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <polygon fill="#7B8FAB" points="163 5 0.5 5 0 5 0 4 0.5 4 163 4 163 0 172 4.5 163 9 163 5"></polygon> </svg>');

      $el.find('.flickity-page-dots .flickity-page-dot').each((i, el) => {
        $(el).text(i + 1);
      });

      $prev.find('svg').remove();
      $prev.append($arrow.clone());
      $next.find('svg').remove();
      $next.append($arrow.clone());
    }

    function check_slide_height(cell, gallery) {
      var $viewport = $(gallery.viewport);
      var $slide = $(cell.element);
      var img_height = $slide.find('img').innerHeight();
      var window_height = window.innerHeight * 0.9;

      if(img_height > window_height) {
        $slide.css('height', window_height);
        $viewport.css('height', window_height);
      }
      else {
        $slide.css('height', img_height);
        $viewport.css('height', img_height);
      }
    }

    $('.gallery').each(function() {
      let gal = new Flickity(this, {
        // options
        contain: true,
        adaptiveHeight: true,
        wrapAround: true,
        imagesLoaded: true,
        setGallerySize: false,
        on: {
          ready: function() {
            change_arrows(this.element);
            check_slide_height(this.cells[0], this);
          },
          change: function(index) {
            check_slide_height(this.cells[index], this);
          },
          settle: function(index) {
            check_slide_height(this.cells[index], this);
          }
        }
      });

      $(window).resize(debounce(() => {
        check_slide_height(gal.cells[gal.selectedIndex], gal);
      }, 500));
    });
  },

  better_ol: function() {
    $('ol li').each(function(i, el) {
      $(el).prepend('<span>' + (i + 1) + '</span>')
    });
  },

  vimeo: function() {

    $('.practice-area-video-section').each(function() {

      var $this = $(this);
      $this.addClass('js-fix');
      var $iframe = $this.find('iframe');
      var player = new window.Vimeo.Player(this);

      function calc(width, height) {
        var ratio = height / width;

        var target = window.innerHeight * 0.9;
        console.log(target, $iframe.innerWidth() * ratio);
        if(target > $iframe.innerWidth() * ratio) {
          target = $iframe.innerWidth() * ratio;
        }
        $iframe.css('height', target);
        $this.css('height', target);
        $this.next().css('margin-top', target);
      }
      Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function(dimensions) {
        $(window).resize(window._.throttle(() => {
          calc(dimensions[0], dimensions[1]);
        }));
        calc(dimensions[0], dimensions[1]);
      });

      player.getVideoTitle().then(function(title) {
        $iframe.attr('title', title);
      }).catch(function(error) {
        // an error occurred
      });
    });
  },

  init: function() {
    this.jump_to_top();
    this.check_for_tab();
    this.hamburgers();
    this.page_gradient();
    this.vimeo();
    this.replace_nbsp();
    this.gallery();

    domReady(() => {
      // Display body when DOM is loaded
      document.body.style.visibility = 'visible';
    });
  }
};

// Helper function
let domReady = (cb) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb);
};

$(window).on('load', function() {
  if($('.attorney-page').length) {
    Attorney.init();
  }
  global.init();
});